import React from 'react';
import PropTypes from 'prop-types';
import RequestRow from '../requestRow';
import RequestTreeList from './';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const style = {
  treePadding: {
    paddingLeft: '30px'
  },
  childrenGroup: {
    borderLeft: '5px dotted #009EE0'
  }
};
export const RequestTreeListView = props => {
  function hasChildren(request) {
    return request.children?.length > 0;
  }
  const rows = props.organisations && props.invitations ? props.requests.map((request, index) => {
    return /*#__PURE__*/_jsxs("div", {
      style: props.treePadding ? style.treePadding : {},
      children: [/*#__PURE__*/_jsx(RequestRow, {
        history: props.history,
        request: request,
        organisations: props.organisations,
        invitations: props.invitations
      }),
      // parent component called reccursively to construct requests tree and display until there is no more children
      hasChildren(request) && /*#__PURE__*/_jsxs("div", {
        style: style.childrenGroup,
        children: [/*#__PURE__*/_jsxs("h3", {
          className: "mb-4",
          style: style.treePadding,
          children: [/*#__PURE__*/_jsx("span", {
            children: props.getRfaOwnerName(request.subcontractorId)
          }), /*#__PURE__*/_jsx("span", {
            className: "separator"
          }), /*#__PURE__*/_jsx("span", {
            style: {
              fontWeight: 'normal'
            },
            children: props.getRfaOwnerRegistrationNumber(request.subcontractorId)
          })]
        }), /*#__PURE__*/_jsx(RequestTreeList, {
          history: props.history,
          getRfaOwnerName: props.getRfaOwnerName,
          getRfaOwnerRegistrationNumber: props.getRfaOwnerRegistrationNumber,
          organisations: props.organisations,
          requests: request.children,
          invitations: props.invitations,
          loading: props.loading,
          treePadding: true
        })]
      })]
    }, index);
  }) : false;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [props.loading && /*#__PURE__*/_jsx("div", {
      className: "loading-overlay"
    }), rows.length > 0 && rows]
  });
};
RequestTreeListView.propTypes = {
  history: PropTypes.object.isRequired,
  getRfaOwnerName: PropTypes.func.isRequired,
  getRfaOwnerRegistrationNumber: PropTypes.func.isRequired,
  organisations: PropTypes.array.isRequired,
  requests: PropTypes.array.isRequired,
  invitations: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  treePadding: PropTypes.bool
};
RequestTreeListView.defaultProps = {
  invitations: [],
  treePadding: false
};
export default RequestTreeListView;